<template>
  <v-layout class="auto-search-wrap">
    <alert-message
      :alert-message="alertObject.message"
      :alert-value="alertObject.value"
      :alert-type="alertObject.type"
      :top-position="-10"
    />
    <v-flex xs4>
      <div class="auto-search-client-name">
        <span>{{
          isSpecificClient ? `Client: ${assignToClient.name}` : ""
        }}</span>
      </div>
    </v-flex>
    <v-flex xs3 md4>
      <auto-search-menu
        v-if="clientSavedAutoSearchList.length && !isSpecificClient"
        menu-text="Load Saved Search"
        menu-type="load"
        :menu-options="clientSavedAutoSearchList"
        :menu-color="colors.hwayzDarkGray"
        @save-load-search="clientSelected($event)"
      />
      <div
        v-else-if="hasSavedAutoSearch()"
        class="auto-search-text"
        @click="
          clientSelected({ selectedClient: assignToClient, type: 'load' })
        "
      >
        <span>LOAD SAVED SEARCH</span>
      </div>
    </v-flex>
    <v-flex xs3 md2>
      <auto-search-menu
        v-if="clientList.length && !isSpecificClient"
        menu-text="Save Search"
        :menu-options="clientList"
        :menu-color="colors.pending"
        @save-load-search="clientSelected($event)"
      />
      <div
        v-else-if="isSpecificClient"
        class="auto-search-text save-btn"
        @click="
          clientSelected({ selectedClient: assignToClient, type: 'save' })
        "
      >
        <span>SAVE SEARCH</span>
      </div>
    </v-flex>
    <v-flex xs2 class="text-xs-center">
      <div class="auto-search-text">
        <span @click="clearSearchClicked">CLEAR</span>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import AutoSearchMenu from './AutoSearchMenu.vue'
import AlertMessage from '../../../uiUtils/AlertMessage.vue'
import {
  createNewAutoSearch,
  updateAutoSearchData
} from '../../../../services/autoSearchService'
import { isEmpty } from '../../../../utils/generalUtils'
import { INITIAL_NEW_QUERY } from '../../../common/searchPropertyConst'
import colors from '../../../../scss/_colors.scss'

export default {
  components: { AutoSearchMenu, AlertMessage },

  props: {
    assignToClient: {
      type: Object,
      required: true
    }
  },

  data: () => ({
    colors,
    alertObject: {
      type: 'success',
      value: false,
      message: ''
    }
  }),

  computed: {
    ...mapState('agent', ['agentData']),
    ...mapState('client', ['clientData']),
    ...mapState('common', ['lastNewQuery']),

    isSpecificClient() {
      console.log(this.assignToClient)
      return !isEmpty(this.assignToClient)
    },

    clientList() {
      return this.agentData ? this.agentData.clients : []
    },

    clientSavedAutoSearchList() {
      return this.clientList.filter(client => !isEmpty(client.autosearch))
    }
  },

  methods: {
    ...mapMutations('agent', {
      setAgentData: 'SET_AGENT_DATA'
    }),
    ...mapMutations('client', {
      setClientData: 'SET_CLIENT_DATA',
      setAssignToClient: 'SET_ASSIGN_TO_CLIENT'
    }),
    ...mapMutations('common', {
      setNewRequestedQuery: 'SET_NEW_REQUESTED_QUERY'
    }),

    hasSavedAutoSearch() {
      return this.assignToClient && !isEmpty(this.assignToClient.autosearch)
    },

    async clientSelected(data) {
      const { selectedClient, type } = data
      if (type === 'save') {
        const { query } = this.lastNewQuery
        const response = isEmpty(selectedClient.autosearch)
          ? await createNewAutoSearch(selectedClient._id, { query })
          : await updateAutoSearchData(
            selectedClient._id,
            selectedClient.autosearch[0]._id,
            { query }
          )
        if (response.status === 200) {
          const updatedClient = {
            ...selectedClient,
            autosearch: [response.data]
          }
          let updatedAgentData = { ...this.agentData }
          updatedAgentData.clients = updatedAgentData.clients.map(client =>
            client._id === updatedClient._id ? updatedClient : client
          )
          this.setAgentData(updatedAgentData)
          this.setClientData(updatedClient)
          // Will be replaced later when all pages were in sync with client data
          this.setAssignToClient(updatedClient)

          this.alertObject = {
            ...this.alertObject,
            value: true,
            message: `New search successfully saved for ${updatedClient.name}`
          }
        } else {
          // Error handling to be added here
          console.log('some error')
        }
      } else if (type === 'load') {
        let updatedAgentData = { ...this.agentData }
        updatedAgentData.clients = updatedAgentData.clients.map(client =>
          client._id === selectedClient._id
            ? { ...client, selectedAutoSearch: true }
            : { ...client, selectedAutoSearch: false }
        )
        this.setAgentData(updatedAgentData)
        this.setNewRequestedQuery(selectedClient.autosearch[0].query)
        this.setAssignToClient(selectedClient)
        this.$emit('on-search-clicked')
      }
    },

    clearSearchClicked() {
      let updatedAgentData = { ...this.agentData }
      updatedAgentData.clients = updatedAgentData.clients.map(client => ({
        ...client,
        selectedAutoSearch: false
      }))
      const defaultQuery = JSON.parse(JSON.stringify(INITIAL_NEW_QUERY))
      this.setAgentData(updatedAgentData)
      this.setNewRequestedQuery(defaultQuery)
      this.setAssignToClient({})
      this.$emit('on-search-clicked')
    }
  }
}
</script>

<style lang="sass">
.auto-search-wrap
  margin-top: 2rem
  padding-bottom: 1rem
  @media only screen and (max-width: 960px)
    font-size: 1.3rem

.auto-search-text
  span
    display: inline-block
    border-radius: 2px
    cursor: pointer
    margin: 6px 8px
    padding: 0 2rem
    height: 36px
    line-height: 36px
    color: $hwayzWhite
    transition: all 0.3s ease-in-out
    font-size: 1.4rem
    @media only screen and (max-width: 960px)
      font-size: 1.3rem
      padding: 0 0.5rem
    &:hover
      background-color: $hwayzDarkerGray
  &.save-btn span
    background-color: $hwayzYellow
    &:hover
      background-color: rgba($hwayzYellow, 0.8)

.auto-search-client-name span
  @extend %disable-selection
  display: inline-block
  margin: 6px 8px
  padding: 0 2rem
  height: 36px
  line-height: 36px
  color: $hwayzWhite
  float: left
</style>
